import * as React from 'react';
export const IcMonster = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.89 9.68a8 8 0 00-2.54-4.62l1.36-1.35a1.004 1.004 0 10-1.42-1.42L15.68 3.9a8 8 0 00-7.36 0L6.71 2.29a1 1 0 00-.33-.22 1.07 1.07 0 00-.76 0 1 1 0 00-.33 1.64l1.36 1.35A8 8 0 005 14.87V19a1 1 0 102 0v-1.76c.605.486 1.28.88 2 1.17V21a1 1 0 102 0v-2.07c.332.043.666.067 1 .07a8.38 8.38 0 001-.07V21a1 1 0 102 0v-2.59a7.888 7.888 0 002-1.17V19a1 1 0 102 0v-4.13a8.07 8.07 0 00.89-5.19zm-12.6 1a1 1 0 01-.12-1.27.94.94 0 01.45-.36A1 1 0 018.2 9a1 1 0 01.8.8 1 1 0 01-.06.58.94.94 0 01-.36.45 1 1 0 01-1.27-.12l-.02-.03zm8.3 3.53a1 1 0 01-.31.51 4.93 4.93 0 01-6.56 0 1 1 0 01-.31-.51 1.08 1.08 0 010-.59 1 1 0 01.36-.47 1 1 0 01.61-.15h5.24a1 1 0 01.57.18 1 1 0 01.36.47c.068.19.082.393.04.59v-.03zm1.12-3.53a1 1 0 01-1.27.12.94.94 0 01-.36-.45A1 1 0 0115 9.8a1 1 0 01.8-.8 1 1 0 01.58.06.94.94 0 01.45.36 1 1 0 01-.12 1.27v-.01z'
      fill='currentColor'
    />
  </svg>
);
